export default class DateUtils {
  static getCurrentYear() {
    return new Date().getFullYear();
  }
}
